// @flow
import * as React from "react";
import type { Game } from "../../common/types";
import { useFirestore, useFirestoreDocDataOnce } from "reactfire";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

type Props = { game: Game };

function GameDetailsContentResults({ game }: Props) {
  const firestore = useFirestore();
  const gameResult = useFirestoreDocDataOnce(
    firestore
      .collection("sams")
      .doc("matches")
      .collection("mappedMatches")
      .doc(game.id)
  );

  if (gameResult == null || gameResult.setPoints == null) {
    return null;
  }

  const { setPoints, ballPoints, sets, netDurationMinutes } = gameResult;

  const Row = ({ label, value }) => (
    <TableRow key={label}>
      <TableCell component="th" scope="row">
        {label}
      </TableCell>
      <TableCell align="right">{value}</TableCell>
    </TableRow>
  );

  return (
    <Table>
      <TableBody>
        <Row label="Ergebnis" value={setPoints} />
        <Row label="Sätze" value={sets.join(", ")} />
        <Row label="Bälle" value={ballPoints} />
        <Row label="Dauer" value={`${netDurationMinutes} Minuten`} />
      </TableBody>
    </Table>
  );
}

export default GameDetailsContentResults;
